import IQVIA_TRIALS from 'common/data/iqvia_trials';

export default function isIQVIATrial(id: string) {
  return IQVIA_TRIALS.includes(id);
}
